import { Component, inject, Signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CardLoaderModule, DetailPopupModule } from '@iot-platform/iot-platform-ui';
import { BaseUser, BusinessProfile, Entity, UserAccount } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';
import { UserInfoPopupService } from '../../services/user-info-popup.service';

@Component({
  imports: [DetailPopupModule, FlexLayoutModule, TranslatePipe, MatIconModule, MatCardModule, CardLoaderModule],
  selector: 'iot-platform-ui-user-detail-dialog',
  templateUrl: './user-detail-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./user-detail-dialog.component.scss']
})
export class UserDetailDialogComponent {
  private readonly userInfoPopupService: UserInfoPopupService = inject(UserInfoPopupService);
  public readonly dialogRef: MatDialogRef<UserDetailDialogComponent> = inject(MatDialogRef<UserDetailDialogComponent>);
  public data: { user: BaseUser } = inject(MAT_DIALOG_DATA);

  userAccount: Signal<UserAccount | undefined> = toSignal(this.userInfoPopupService.getUserAccountById(this.data.user.id));
  businessProfiles: Signal<BusinessProfile[] | undefined> = toSignal(this.userInfoPopupService.getBusinessProfilesByUserId(this.data.user.id));
  userEntities = this.data.user?.entities.map((entity: Entity) => entity.name).join(', ') ?? '';
}
